import * as Linking from 'expo-linking';

export const getSSOData = (url) => {
  if (!url) {
    return { isValid: false };
  }
  const { path } = Linking.parse(url);
  const [login, sso, uuid] = path ? path.split('/') : [];

  return {
    uuid: uuid,
    password: 'SSO',
    isValid: login === 'login' && sso === 'sso' && uuid,
  };
};
